import React from 'react';
import { bool, node, string } from 'prop-types';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import classNames from 'classnames/bind';
import styles from './component-selector.module.scss';

export const ComponentSelectorWrapper = ({ showPlaceholder, children, backgroundColor }) => {
  const cx = classNames.bind(styles);

  const placeholderStyles = cx({
    'component-selector__wrapper': showPlaceholder,
    'component-selector__hidden': !showPlaceholder,
  });
  const backgroundStyles = cx({
    'component-selector__background': showPlaceholder,
    'component-selector__hidden': !showPlaceholder,
  });

  return (
    <div style={{ position: 'relative' }}>
      <Placeholder className={placeholderStyles} />
      <div className={backgroundStyles} style={{ backgroundColor }} />
      {children}
    </div>
  );
};

ComponentSelectorWrapper.propTypes = {
  showPlaceholder: bool,
  children: node.isRequired,
  backgroundColor: string
};

ComponentSelectorWrapper.defaultProps = {
  showPlaceholder: false,
  backgroundColor: 'white'
};
